module.exports = __webpack_public_path__ + "img/demo1.99a7c09c.png";